/* eslint-disable vue/require-name-property */
import '/@front:css/style.css'

import { createApp, reactive } from 'petite-vue'
import axios from 'redaxios'

function toggleNavigation() {
  store.showNavigation = !store.showNavigation
  document.body.classList.toggle('noscroll', store.showNavigation)
}

function toggleSubNav(event: MouseEvent) {
  const el = (event.target as HTMLAnchorElement).closest('li')
  if (el) {
    el.classList.toggle('subnav-active')
  }
}

function logout() {
  axios
    .post(
      '/logout',
      {},
      {
        headers: {
          accept: 'application/json',
        },
      },
    )
    .then(() => {
      location.assign('/')
    })
}

function handleFormSubmit() {
  store.formIsProcessing = true

  axios({
    method: 'POST',
    url: location.pathname,
    headers: {
      accept: 'application/json',
    },
    data: store.form,
  })
    .then((_r) => {
      store.formWasSubmitted = true
      location.assign('/')
    })
    .catch((error) => {
      const errors = error.data?.errors || {}
      Object.keys(errors).forEach((key) => {
        const message = errors[key].pop()
        if (message) {
          store.formErrors[key] = message
        }
      })
    })
    .finally(() => {
      store.formIsProcessing = false
    })
}

const store = reactive({
  showNavigation: false,
  toggleNavigation,
  toggleSubNav,
  logout,
  form: {
    email: '',
    password: '',
  },
  formIsProcessing: false,
  formWasSubmitted: false,
  formErrors: {},
  handleFormSubmit,
})

createApp({
  store,
}).mount('body')
